export default __webpack_public_path__ + "static/media/testi2.2aca1142.png";